export const SET_WEBRTC_PLAY_WEBSOCKET="SET_WEBRTC_PLAY_WEBSOCKET";
export const SET_WEBRTC_PLAY_PEERCONNECTION="SET_WEBRTC_PLAY_PEERCONNECTION";
export const SET_WEBRTC_PLAY_CONNECTED="SET_WEBRTC_PLAY_CONNECTED";
export const SET_WEBRTC_PLAY_AUDIO_TRACK='SET_WEBRTC_PLAY_AUDIO_TRACK';
export const SET_WEBRTC_PLAY_VIDEO_TRACK='SET_WEBRTC_PLAY_VIDEO_TRACK';
